export default {
  selectedRoomId: null, // 汎用カテゴリー
  optionVersionIds: [],
  selectedVersionId: null,

  // データ検索条件
  channelTimeFrom: null, //"2020-10-12T01:55:00.000Z",
  channelTimeTo: null,

  lastChannelTimeFrom: null, //検索したデータ期間一時保存
  lastChannelTimeTo: null,

  // トレンドデータ
  rooms: [],
  
  // X軸マウスフォーカスポイント
  channelGroupFocusPointMap: {
    // room_id: time
  }
}